import { ICONS_COMPONENTS } from '../EmojiPicker/constants'

export const NoteIconVariant = {
  Private: 'private',
  Personal: 'personal',
} as const

// Type derived from the object values
export type NoteIconVariant =
  (typeof NoteIconVariant)[keyof typeof NoteIconVariant]

function isNoteIconVariant(value: string): value is NoteIconVariant {
  return value in NoteIconVariant
}

export function toNoteIconVariant(value: string | null) {
  if (value !== null && isNoteIconVariant(value)) {
    return value
  }
  return null
}

export function toNoteIconComponent(iconShape: string) {
  if (iconShape in ICONS_COMPONENTS) {
    return ICONS_COMPONENTS[iconShape as keyof typeof ICONS_COMPONENTS]
  }
  return null
}
